/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { useEffect, useRef } from 'react';

export const usePrevious = (value) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
